import React from "react";
import useAuth from "../hooks/useAuth";

export default function Dashboard() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-500">Welcome back, {user.name}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          { label: "Active Campaigns", value: "—", color: "blue" },
          { label: "Messages Sent Today", value: "—", color: "green" },
          { label: "Pending Replies", value: "—", color: "yellow" },
          { label: "Opt-out Rate", value: "—", color: "red" },
        ].map((stat) => (
          <div key={stat.label} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <p className="text-sm font-medium text-gray-500">{stat.label}</p>
            <p className="text-3xl font-bold text-gray-900 mt-2">{stat.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { label: "New Campaign", href: "/campaigns/new", role: ["admin", "manager"] },
            { label: "Upload Contacts", href: "/contacts/upload", role: ["admin", "manager"] },
            { label: "Sending Console", href: "/send", role: ["admin", "manager", "texter"] },
            { label: "Reply Inbox", href: "/replies", role: ["admin", "manager", "texter"] },
          ]
            .filter((a) => a.role.includes(user.role))
            .map((action) => (
              <a
                key={action.label}
                href={action.href}
                className="bg-gray-50 hover:bg-blue-50 border border-gray-200 rounded-lg p-4 text-center text-sm font-medium text-gray-700 hover:text-blue-700 transition-colors"
              >
                {action.label}
              </a>
            ))}
        </div>
      </div>
    </div>
  );
}
